// @flow

import React, { type Node, useState } from 'react';

import { useSendVoucherGenerateEvent } from '@tectonics/analytics';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { IfFeature } from '@tectonics/prs/feature';
import { Separator, Button } from '../../../../../atoms';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import styled  from 'styled-components';
import { usePendingIncomingPayment, getSafeOxxoUrl } from '@tectonics/prs/incoming-payment';

import { OxxoNumberDisplay } from './oxxo-number';
import { OxxoBarcode } from './oxxo-barcode';
import { OxxoMapLink } from './oxxo-map-link';
import { OxxoTipsBox } from './oxxo-tips-box';

import {
  VoucherMailWarning,
  VoucherTicket,
  VoucherTicketAmount,
  VoucherTicketDueDate,
} from '../../commons/voucher';

export function OxxoPageContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const features = useAllFeatures();
  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendVoucherGenerateEvent(isReady);

  return (
    <div data-test-id="page-pending-payment" className="content-box content-box__row">

      <p style={OxxoTitleStyle}>
        Tu voucher OXXO fue generado.
      </p>

      <IfFeature allFeatures={features} wanted="display_oxxo_instructions">
        <VoucherMailWarning />
      </IfFeature>
      <Separator direction="vertical" size={5}/>

      <VoucherTicket>
        <IfFeature allFeatures={features} wanted="display_oxxo_total_amount">
          <VoucherTicketAmount />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="display_oxxo_duedate">
          <VoucherTicketDueDate />
        </IfFeature>
      </VoucherTicket>

      <Separator pattern="dotted" direction="vertical" size={5.5} />

      <CenterWrapper>
        <IfFeature allFeatures={features} wanted="display_oxxo_barcode">
          <OxxoBarcode />
        </IfFeature>

        <Separator direction="vertical" size={4}/>

        <IfFeature allFeatures={features} wanted="display_oxxo_number">
          <OxxoNumberDisplay />
        </IfFeature>

        <Separator direction="vertical" size={4}/>

        <IfFeature allFeatures={features} wanted="display_oxxo_payment_locations">
          <OxxoMapLink />
        </IfFeature>

        <Separator direction="vertical" size={4}/>

        <IfFeature allFeatures={features} wanted="action_oxxo_save_pdf">
          <LinkButton type="primary" block as="a" target="_blank" href={`${getSafeOxxoUrl(incomingPayment)}&format=pdf`}>
            Guardar instrucciones en PDF
          </LinkButton>

        </IfFeature>

        <Separator direction="vertical" size={4}/>
      </CenterWrapper>

      <Separator pattern="dotted" direction="vertical" size={5.5} />

      <IfFeature allFeatures={features} wanted="display_oxxo_tips">
        <OxxoTipsBox />
      </IfFeature>
    </div>
  );
}

const OxxoTitleStyle = {
  fontSize: '22px',
  marginBottom: '16px',
  color: '#2397d4',
};

const CenterWrapper = styled.div`
  @media(min-width: 990px){
    width: 70%;
    margin: auto;
  }
`;

const LinkButton = styled(Button)`
  padding: 16px 0px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;
